module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-floating-live js-floating-live u-fixed u-bg--black",
    class: [_vm.isHidden ? 'is-hidden' : '', _vm.isOverlayHidden ? 'is-overlay-hidden' : '', _vm.isHovered ? 'is-hovered' : ''],
    on: {
      "touchstart": _vm.onTouchDown,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd,
      "mouseenter": function($event) {
        _vm._onMouseenter()
      },
      "mouseleave": function($event) {
        _vm._onMouseleave()
      },
      "click": function($event) {
        _vm._onClick()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "c-floating-live__overlay u-absolute u-index--2 u-fit"
  }, [_c('div', {
    staticClass: "c-floating-live__overlay__close-container u-absolute u-pos-tr u-index--1 u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._hide()
      }
    }
  }, [_c('div', {
    staticClass: "c-floating-live__overlay__close-container__bar-tl u-absolute u-bg--red-pure"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-floating-live__overlay__close-container__bar-bl u-absolute u-bg--red-pure"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-floating-live__overlay__mute-container u-absolute u-pos-br u-index--1 u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._toggleIsMuted()
      }
    }
  }, [(_vm.isMuted) ? _c('img', {
    staticClass: "c-floating-live__overlay__mute-container__icon",
    attrs: {
      "src": "/static/floating-live/icon-sound--off.png"
    }
  }) : _c('img', {
    staticClass: "c-floating-live__overlay__mute-container__icon",
    attrs: {
      "src": "/static/floating-live/icon-sound--on.png"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "c-floating-live__overlay__text-container u-absolute u-pos-center--3d u-index--2 u-fit-w u-align-center",
    attrs: {
      "to": _vm.$root.getPageURLFromID('watchNow')
    }
  }, [_c('span', {
    staticClass: "u-uppercase u-color--red-pure"
  }, [_vm._v("\n                Watch\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-floating-live__video js-twitch-player u-index--1"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-floating-live__loader u-absolute u-pos-tl u-index--3 u-fit u-bg--black u-overflow-h"
  }, [_c('img', {
    staticClass: "c-floating-live__loader__img u-absolute",
    attrs: {
      "src": require("../../../assets/loader/loader-sprite-map.png"),
      "alt": "Loader"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-floating-live__marker u-absolute u-pos-tl u-index--4 u-bg--red-pure"
  }, [_c('span', {
    staticClass: "u-uppercase u-color--white"
  }, [_vm._v("GfinityTV")]), _vm._v(" "), _c('div', {
    staticClass: "c-floating-live__marker__border-right u-absolute u-fit-h u-bg--red-pure"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d13f3b8"}!./src/scripts/components/app-floating-live/template.html
// module id = 898
// module chunks = 0